/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EnvironmentVariableKind,
  EnvironmentVariableKind$inboundSchema,
} from "./environmentvariablekind.js";

export type EnvironmentVariable = {
  /**
   * The variable name.
   */
  key: string;
  /**
   * How the value may be read back. `writeonly` values can never be read back
   *
   * @remarks
   * through the API; `recoverable` values can be decrypted. Values are encrypted
   * at rest either way.
   */
  kind: EnvironmentVariableKind;
  /**
   * The decrypted plaintext value. Present only for `recoverable` variables.
   *
   * @remarks
   * Omitted for `writeonly` variables, which can never be read back.
   */
  value?: string | undefined;
  /**
   * Human-readable description. Omitted if none was provided.
   */
  description?: string | undefined;
  /**
   * Unix timestamp in milliseconds when the variable was created.
   */
  createdAt: number;
};

/** @internal */
export const EnvironmentVariable$inboundSchema: z.ZodType<
  EnvironmentVariable,
  z.ZodTypeDef,
  unknown
> = z.object({
  key: z.string(),
  kind: EnvironmentVariableKind$inboundSchema,
  value: z.string().optional(),
  description: z.string().optional(),
  createdAt: z.number().int(),
});

export function environmentVariableFromJSON(
  jsonString: string,
): SafeParseResult<EnvironmentVariable, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EnvironmentVariable$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EnvironmentVariable' from JSON`,
  );
}
